import {gql, useQuery} from '@apollo/client'
import {useGetFiltersDataMap} from './getFiltersDataMap'
import {usePersona} from '../../../store/hooks/persona'

export default function usePersonaByCensusTractQuery() {
  const personaByCensusTractQuery = gql`
    query GetPersonaByCensusTract($filters: Filters, $benefits: [BenefitEligibility]) {
      personaCensusTract(filters: $filters, benefits: $benefits) {
        personaCensusTract {
          state: st
          county: cty
          censusTractGeoId: ctId
          total_population: tPop
          dominant_persona: dPer
          persona_cohort: pCo
          persona_population: pPop
          censusTractPopulation: ctPop
          censusTractPercentage: ctPer
          countyPercentage: ctyPer
        }
        missingGeoIds
      }
    }
  `

  const {filtersDataMap, benefitsData} = useGetFiltersDataMap()
  const {personasToggle} = usePersona()

  const {
    data: personaByCensusTractData,
    loading: loadingPersonaByCensusTract,
    refetch: refetchPersonaByCensusTract,
    error: errorLoadingPersonaByCensusTract
  } = useQuery(personaByCensusTractQuery, {
    variables: {
      filters: filtersDataMap,
      benefits: benefitsData[0]
    },
    skip: !personasToggle,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first'
  })

  return {
    personaByCensusTract: personaByCensusTractData,
    loadingPersonaByCensusTract,
    refetchPersonaByCensusTract,
    personaByCensusTractError: errorLoadingPersonaByCensusTract
  }
}
